/**
 * The different pages that a Navigation Action can lead to within the application.
 */
export enum NavigationActionPage {
    HOME = 'home',
    CATALOG = 'catalog',
    ORDERS = 'orders',
    COUPONS = 'coupons',
    NEWS = 'news',
    PROMOTIONS = 'promotions',
    LISTS = 'lists',
    USUAL_PURCHASE = 'usual-purchase',
    BEST_SELLERS = 'best-sellers',
    COMPARATOR = 'comparator',
    CHANGE_EMAIL = 'change-email',
    CHANGE_PASSWORD = 'change-password',
    CHECKOUT = 'checkout',
    LIST_DETAIL = 'list-detail',
    ACCOUNT = 'account',
    CATEGORIES = 'categories',
    PRODUCT_DETAIL = 'product-detail',
    PROMOTION_DETAIL = 'promotion-detail',
    LOGIN = 'login',
    SERVICE_UNAVAILABLE = 'service-unavailable',
    SHARED = 'shared',
}

/**
 * The action of navigating to a specific screen within the application with optional parameters.
 */
export class NavigationAction {
    constructor(
        readonly page: NavigationActionPage,
        readonly parameters?: Record<string, any>,
    ) {}
}
